import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import qs from 'query-string';

import { Spinner } from '../../common/components';
import * as actions from '../actions';
import { CLASSTING_AUTH_URL, CLASSTING_CLIENT_ID } from '../../common/constants';
import RedirectOrgService from '../errors/RedirectOrgService';

const AuthCallback = ({ history, location }) => {
  const accessToken = useSelector(state => state.auth.accessToken);
  const authError = useSelector(state => state.auth.error);

  const dispatch = useDispatch();

  const { pathname, search } = qs.parse(window.sessionStorage.getItem('redirect_url'));

  const getSchoolIdFromPathname = useCallback(() => {
    if (pathname) {
      const segments = pathname.split('/');

      if (segments.length > 2 && segments[1] === 'schools') {
        return segments[2];
      }
    }

    return null;
  }, [pathname]);

  useEffect(() => {
    if (location.hash) {
      const params = qs.parse(location.hash);
      dispatch(actions.setAuthRequest({ accessToken: params.access_token, schoolId: getSchoolIdFromPathname() }));
    } else {
      const params = qs.stringify({
        client_id: CLASSTING_CLIENT_ID,
        response_type: 'id_token token',
        scope: 'openid email profile',
        nonce: Math.random().toString(36).substring(10),
        redirect_uri: `${window.location.origin}/users/callback`,
      });

      window.location.replace(`${CLASSTING_AUTH_URL}/auth?${params}`);
    }
  }, [dispatch, location, getSchoolIdFromPathname]);

  useEffect(() => {
    if (authError instanceof RedirectOrgService) {
      const orgUrl = process.env.NODE_ENV === 'production' ? 'https://organization.classting.com' : 'https://organization.classting.net';
      window.location.replace(`${orgUrl}/schools/${getSchoolIdFromPathname()}/newsletters`);
    }
  }, [authError, getSchoolIdFromPathname, history]);

  return accessToken
    ? (
      <Redirect
        to={{
          pathname,
          search,
          state: { from: location.pathname },
        }}
      />
    )
    : <Spinner />;
};

AuthCallback.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
    state: PropTypes.shape({
      from: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    }),
  }).isRequired,
};

export default AuthCallback;
